import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { Button } from 'reactstrap';

import FileAccess from './Access';
import FileActions from './Actions';
import FileSize from './Size';
import FileResolution from './Resolution';
import { userCan } from '../../helpers/Auth';

const FileEditionsItem = ({
  file,
  fileEdition,
  handleEditionChangeSearchable,
  switchEdition,
  collection,
  share,
}) => {
  const isEditionActive = () => {
    if (!file || !fileEdition) return false;
    if (file.uuid === fileEdition.uuid) return true;
    return false;
  };

  if (!file) return null;

  return (
    <div
      key={file.uuid}
      className={classnames('file-editions-element', { 'file-editions-element-active': isEditionActive() })}
    >
      <Button color="link" onClick={() => switchEdition(file)}>
        <img
          width="100%"
          src={file.urls.thumbnail}
          srcSet={`${file.urls.thumbnail} 1x, ${file.urls.thumbnailx2} 2x`}
          alt={file.display_name}
        />
      </Button>
      <div className="file-editions-meta">
        <h5 className="file-name">{file.display_name}</h5>
        <div className="file-details">
          <div>
            {(file.searchable || (!file.searchable && !userCan('file.change_access', file))) && (
              <FileAccess
                file={file}
                callbackUpdate={handleEditionChangeSearchable}
                searchable={file.searchable}
                alias="FileEditions"
              />
            )}
            <FileResolution
              file={file}
            />
            <FileSize
              file={file}
            />
            {(!file.searchable && userCan('file.change_access', file)) && (
              <div>
                <FileAccess
                  file={file}
                  callbackUpdate={handleEditionChangeSearchable}
                  searchable={file.searchable}
                  alias="FileEditions"
                />
              </div>
            )}
          </div>
        </div>
        <div className="grid-item-actions">
          <FileActions
            file={file}
            collection={collection}
            shareUuid={share ? share.uuid : null}
            share={share}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  collection: state.Collections.collection,
  share: state.Shares.share,
});

FileEditionsItem.propTypes = {
  file: PropTypes.object.isRequired,
  collection: PropTypes.object,
  share: PropTypes.object,
  handleEditionChangeSearchable: PropTypes.func.isRequired,
  fileEdition: PropTypes.object,
  switchEdition: PropTypes.func.isRequired,
};

FileEditionsItem.defaultProps = {
  fileEdition: null,
  collection: null,
  share: null,
};

export default connect(mapStateToProps)(FileEditionsItem);
